import styled from 'styled-components';
import IconGroup from '../icon-group';
export const ToolBarActions = styled(IconGroup) `
  background-color: transparent;
  border: none;
  --ggs: 1;
`;
